export default __webpack_public_path__ + "static/media/whale4.645c931b.png";